import { TableProps } from '@aibees/shared/components';
import { useEffect, useState } from 'react';
import { SaveRecordAction } from '../types';
import { usePersonEnrichableCountMutationApi } from './use-person-enrichable-count-mutation-api';

export function useSaveRecordEnrichableCount(
  action: SaveRecordAction,
  table?: TableProps
) {
  const [enrichable, setEnrichable] = useState<number>();
  const [unEnrichable, setUnEnrichable] = useState<number>();

  const { mutateAsync, isLoading } = usePersonEnrichableCountMutationApi();

  useEffect(() => {
    if (table?.selection.included.length) {
      mutateAsync({
        ids: table?.selection.included,
        actions: [action],
      }).then((data) => {
        const enrichDetail = data.enrichable[action];
        setEnrichable(enrichDetail?.enrichable);
        setUnEnrichable(enrichDetail?.unEnrichable);
      });
    }
  }, [table?.selection.included, action]);

  return { enrichable, unEnrichable, isLoading };
}
